import {FACTION_CONFIGS} from "../../configs/factions";
import {UNIT_TYPES} from "../../configs/units";
import {
  FACTION_CAMPAIGN_STATUS_TITLES,
  FACTION_CAMPAIGN_STATUSES,
  FACTION_NAME_GENITIVE,
  FACTIONS_WITH_CAMPAIGN_IN_DEVELOPMENT
} from "../../configs/factionCampaigns";

// Порядок групп в списке кампаний: сначала те, что уже делаются, затем
// запланированные по фракциям игрока, затем по остальным реализованным
// фракциям, и в конце — по нереализованным
const getCampaignSortWeight = (factionConfig, isOwned) => {
  if (FACTIONS_WITH_CAMPAIGN_IN_DEVELOPMENT.includes(factionConfig.id)) {
    return 0;
  }
  if (isOwned) {
    return 1;
  }
  return factionConfig.implemented ? 2 : 3;
};

// Отряд, скин которого представляет кампанию фракции: d20 (самый крупный
// отряд), а если фракция явно перечисляет свои типы отрядов и d20 среди них
// нет (например, Духи) — последний из перечисленных
const getCampaignUnitTypeId = (factionConfig) => {
  const {unitTypes} = factionConfig;

  if (!unitTypes || unitTypes.length === 0 || unitTypes.includes(UNIT_TYPES.D20.id)) {
    return UNIT_TYPES.D20.id;
  }

  return unitTypes[unitTypes.length - 1];
};

/**
 * Список сюжетных кампаний фракций для страницы миссий: по одной на фракцию,
 * отсортированный по готовности кампании и доступности фракции игроку.
 * Внутри группы сохраняется порядок FACTION_CONFIGS.
 *
 * @param {string[]} ownedFactionIds - id фракций, открытых у пользователя
 * @returns {Array<{factionId: string, unitTypeId: string, title: string, status: string, statusTitle: string}>}
 */
export const getFactionCampaigns = (ownedFactionIds = []) => {
  return FACTION_CONFIGS
    .map((factionConfig, index) => {
      const isInDevelopment = FACTIONS_WITH_CAMPAIGN_IN_DEVELOPMENT.includes(factionConfig.id);
      const status = isInDevelopment
        ? FACTION_CAMPAIGN_STATUSES.IN_DEVELOPMENT
        : FACTION_CAMPAIGN_STATUSES.PLANNED;

      return {
        factionId: factionConfig.id,
        unitTypeId: getCampaignUnitTypeId(factionConfig),
        title: `Кампания ${FACTION_NAME_GENITIVE[factionConfig.id] || factionConfig.name}`,
        status,
        statusTitle: FACTION_CAMPAIGN_STATUS_TITLES[status],
        sortWeight: getCampaignSortWeight(factionConfig, ownedFactionIds.includes(factionConfig.id)),
        index,
      };
    })
    .sort((a, b) => a.sortWeight - b.sortWeight || a.index - b.index)
    .map(({sortWeight, index, ...campaign}) => campaign);
};
